<template>
    <main-layout>
        <inertia-head>
            <title>Create New User</title>
        </inertia-head>

        <template #header>
            <header-component></header-component>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto px-4 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="font-medium text-xl text-secondary mb-2">
                            Create New User
                        </div>

                        <form @submit.prevent="submit">
                            <div
                                class="
                                    grid grid-cols-1
                                    lg:grid-cols-2 lg:gap-4
                                    mb-4
                                "
                            >
                                <!-- Name -->
                                <div class="py-2">
                                    <message-input-component
                                        id="name"
                                        type="text"
                                        class="w-full"
                                        v-model="form.name"
                                        placeholder="Name"
                                        required
                                        autocomplete="name"
                                    />
                                </div>

                                <!-- Email -->
                                <div class="py-2">
                                    <message-input-component
                                        id="email"
                                        type="email"
                                        class="w-full"
                                        v-model="form.email"
                                        placeholder="Email Address"
                                        required
                                        autocomplete="username"
                                    />
                                </div>

                                <!-- Password -->
                                <div class="py-2">
                                    <message-input-component
                                        id="password"
                                        type="password"
                                        class="w-full"
                                        v-model="form.password"
                                        placeholder="Password"
                                        required
                                        autocomplete="new-password"
                                    />
                                </div>

                                <!-- Confirm Password -->
                                <div class="py-2">
                                    <message-input-component
                                        id="password_confirmation"
                                        type="password"
                                        class="w-full"
                                        v-model="form.password_confirmation"
                                        placeholder="Confirm Password"
                                        required
                                        autocomplete="new-password"
                                    />
                                </div>
                            </div>

                            <div
                                class="
                                    mb-4
                                    flex
                                    justify-center
                                    lg:justify-end
                                    items-center
                                "
                            >
                                <!-- Submit Button -->
                                <button-component
                                    class="flex justify-end"
                                    :class="{
                                        'opacity-25': form.processing,
                                    }"
                                    :disable="form.processing"
                                >
                                    Register
                                </button-component>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from "@/Layouts/Main";
import HeaderComponent from "@/Components/Dashboard/Header";
import ButtonComponent from "@/Components/Button";
import MessageInputComponent from "@/Components/MessageInput";

export default {
    components: {
        MainLayout,
        HeaderComponent,
        ButtonComponent,
        MessageInputComponent,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: false,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.route("register"), {
                onFinish: () =>
                    this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>
